import { render } from "./ProductDataImage.vue?vue&type=template&id=179452d4&scoped=true"
import script from "./ProductDataImage.vue?vue&type=script&lang=js"
export * from "./ProductDataImage.vue?vue&type=script&lang=js"

import "./ProductDataImage.vue?vue&type=style&index=0&id=179452d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-179452d4"]])

export default __exports__